module.exports = __webpack_public_path__ + "static/media/landvesticon.382ca06f.svg";